// Import styles
import '../styles/main.css'
import '../styles/navbar.css'
import '../styles/hero.css'
import '../styles/about.css'
import '../styles/services.css'
import '../styles/video-gallery.css'
import '../styles/faq.css'
import '../styles/contact.css'
import '../styles/responsive.css'
import '../styles/privacy-modal.css'
import '../styles/toast.css'
import '../styles/whatsapp-float.css'

// Import components
import { Navbar } from '../components/navbar'
import { Hero } from '../components/hero'
import { About } from '../components/about'
import { Services } from '../components/services'
import { VideoGallery } from '../components/video-gallery'
import { FAQ } from '../components/faq'
import { renderContactSection } from '../components/contact'
import { privacyModal } from '../components/privacy-modal'
import { dataProtectionModal } from '../components/data-protection-modal'
import { initWhatsAppFloat } from '../components/whatsapp-float'

// Import i18n system
import { i18n } from '../utils/i18n'

// Import page transitions
import { initPageTransitions, navigateWithTransition } from '../utils/page-transitions'

// BeSafe Landing Page Entry Point
console.log('BeSafe Landing Page - Inicializando...')

// Initialize page transitions
initPageTransitions()

// Initialize i18n system
console.log(`Idioma actual: ${i18n.getCurrentLanguage()}`)

// Initialize app
const app = document.querySelector<HTMLDivElement>('#app')!

// Create navbar
const navbar = new Navbar({
  logoSrc: '/besafe_color_positivo_blanco.svg',
  menuItems: [
    { labelKey: 'nav.services', sectionId: 'services' },
    { labelKey: 'nav.about', sectionId: 'about' },
    { labelKey: 'nav.faq', sectionId: 'faq' },
    { labelKey: 'nav.contact', sectionId: 'contact' }
  ],
  onLoginClick: () => {
    const appUrl = import.meta.env.VITE_APP_CLOUDFRONT_URL
    if (appUrl) {
      console.log('Login button clicked - redirecting to app:', appUrl)
      window.open(appUrl, '_blank')
    } else {
      console.log('Login button clicked - VITE_APP_CLOUDFRONT_URL not set, falling back to login page')
      navigateWithTransition('/login.html')
    }
  },
})

// Render navbar
const navbarElement = navbar.render()
document.body.insertBefore(navbarElement, app)

// Create hero section
const hero = new Hero({
  ctaText: 'Arrendar Nunca fue tan fácil',
  subtitle: 'Somos la alternativa que facilita el acceso al mercado inmobiliario mediante análisis legal y financiero ágil. Gestiona todo tu proceso desde nuestra plataforma',
  heroImage: '/01 Somos la alternativa que facilita.jpg',
  uploadButtonText: 'Iniciar estudio',
  paymentButtonText: 'Pagos Mensuales',
  onUploadClick: () => {
    console.log('Upload documents button clicked - navigating to study request wizard')
    navigateWithTransition('/study-request/')
  },
  onPaymentClick: () => {
    console.log('Payment center button clicked - redirecting to login')
    navigateWithTransition('/login.html')
  }
})

// Render hero section
const heroElement = hero.render()
app.appendChild(heroElement)

// Create services section
const services = new Services({
  title: 'Nuestros Servicios',
  items: [
    {
      title: 'Estudio de Crédito Digital',
      content: 'Análisis ágil para tu próximo arrendamiento. Evaluamos tu perfil legal y financiero en tiempo récord para que no pierdas el inmueble que quieres',
      button: 'Iniciar Estudio'
    },
    {
      title: 'Gestión de Pagos y Recaudo',
      content: 'Tus pagos al día, sin complicaciones. Una plataforma centralizada para el pago de tus cuotas mensuales con total transparencia',
      button: 'Ir a Pagos'
    },
    {
      title: 'Respaldo Integral Be Safe',
      content: 'Protección 360° para propietarios e inmobiliarias. Cubrimos el análisis legal, financiero y operativo para garantizar arrendamientos seguros',
      button: 'Ver Políticas'
    }
  ],
  howItWorks: {
    title: 'Arrendar y pagar nunca fue tan sencillo',
    subtitle: 'Para Arrendatarios Nuevos (Estudio de Crédito)',
    steps: [
      'Solicitud Online: Completa el formulario de estudio de crédito desde nuestra plataforma en minutos.',
      'Carga Segura: Sube tus documentos de soporte con protocolos de alta seguridad.',
      'Análisis Integral: Nuestro equipo experto realiza la evaluación legal y financiera.',
      'Aprobación y Firma: Recibe tu respuesta y formaliza tu arrendamiento con total seguridad.'
    ],
    currentClients: {
      subtitle: 'Para Clientes Actuales (Pago de Cuotas)',
      steps: [
        'Ingreso: Accede a tu portal privado con tu usuario y contraseña.',
        'Consulta: Visualiza tu estado de cuenta y cuotas pendientes de forma transparente.',
        'Pago Ágil: Realiza el pago a través de nuestros canales digitales integrados.',
        'Soporte: Descarga tus comprobantes y certificados al instante.'
      ]
    },
    closing: 'Y así de FÁCIL arriendas tu inmueble con BESAFE',
    imageSrc: '/02 Arrendar y pagar nunca fue tan sencillo .JPG',
    currentClientsImageSrc: '/03 Para Clientes Actuales.jpg'
  },
  onUploadClick: () => {
    console.log('Upload documents button clicked - navigating to study request wizard')
    navigateWithTransition('/study-request/')
  },
  onPaymentClick: () => {
    console.log('Payment center button clicked - redirecting to login')
    navigateWithTransition('/login.html')
  },
  onPolicyClick: () => {
    console.log('Policy button clicked - opening data protection modal')
    dataProtectionModal.open()
  }
})

// Render services section
app.appendChild(services.element)
// Initialize services component after it's in the DOM
services.init()

// Create video gallery section
const videoGallery = new VideoGallery({
  title: 'Centro de Guía y Servicios',
  videos: [
    {
      title: '¿Cómo Opera un Modelo BESAFE?',
      description: 'Explica cómo solicitar el estudio a través de la plataforma y la facilidad de cargar documentos de forma segura.',
      youtubeIds: {
        es: 'cG0qc5WeAgM',
        en: 'RaYB1s2hcHw'
      }
    }
  ]
})

// Render video gallery section
app.appendChild(videoGallery.element)
// Initialize video gallery component after it's in the DOM
videoGallery.init()

// Create about us section
const about = new About({
  whoWeAre: {
    title: 'Nuestra razón de ser',
    content: 'Existimos para derribar las barreras del mercado inmobiliario. Combinamos la tecnología con el respaldo jurídico de Apriori Legal SAS para que más personas accedan a un techo de forma segura, ágil y transparente',
    imageSrc: '/04 Nuestra razon de ser .jpg'
  },
  values: {
    title: 'Valores: De "Palabras" a "Garantías"',
    items: [
      {
        title: 'Respaldo Jurídico Total',
        content: 'Cada operación está protegida para cuidar los intereses de todas las partes. No solo somos una web, somos expertos legales.'
      },
      {
        title: 'Inclusión Financiera',
        content: 'Facilitamos el acceso al mercado para nuevos perfiles, promoviendo la equidad y nuevas oportunidades de vivienda.'
      },
      {
        title: 'Innovación Transparente',
        content: 'Utilizamos tecnología para que tus procesos sean claros, rápidos y sin letras chiquitas.'
      }
    ]
  }
})

// Render about us section
const aboutElement = about.render()
app.appendChild(aboutElement)

// Create FAQ section
const faq = new FAQ({
  title: 'Preguntas Frecuentes',
  subtitle: 'Encuentra respuestas a las preguntas más comunes sobre nuestros servicios',
  items: [
    {
      question: '¿Qué es Be Safe?',
      answer: 'Be Safe es una solución creada por Apriori Legal S.A.S. que facilita el arrendamiento de inmuebles cuando el arrendatario no cumple con los requisitos de una aseguradora tradicional. Actuamos como respaldo dentro del proceso de arrendamiento, generando seguridad para propietarios, inmobiliarias y arrendatarios.'
    },
    {
      question: '¿Be Safe es una inmobiliaria?',
      answer: 'No. Be Safe no administra inmuebles. Trabajamos en alianza con inmobiliarias y propietarios, brindando respaldo dentro del proceso de arrendamiento.'
    },
    {
      question: '¿Quiénes pueden acceder al servicio?',
      answer: 'El servicio está pensado para personas o empresas que pueden tener dificultades para ser aprobadas por aseguradoras tradicionales, por ejemplo: Extranjeros sin historial crediticio en Colombia, Personas naturales sin historial financiero en el país, Pymes sin trayectoria crediticia sólida, Arrendatarios con reportes menores en centrales de riesgo.'
    },
    {
      question: '¿Cómo funciona el proceso?',
      answer: 'El proceso es simple: La inmobiliaria o el propietario remite la información del interesado. Se solicita documentación para el análisis. Se realiza un estudio de viabilidad financiera y jurídica. Si el perfil es aprobado, se formalizan los acuerdos. Se entrega un respaldo económico y se inicia el arrendamiento.'
    },
    {
      question: '¿Qué es el estudio de viabilidad?',
      answer: 'Es una evaluación que permite verificar la capacidad económica y los antecedentes del arrendatario para asegurar que pueda cumplir con las obligaciones del contrato de arrendamiento.'
    },
    {
      question: '¿Cuánto cuesta el estudio?',
      answer: 'Persona natural: $238.000 (IVA incluido). Persona jurídica: $357.000 (IVA incluido). El estudio se realiza normalmente en un plazo aproximado de 48 horas hábiles después de recibir los documentos y el comprobante de pago.'
    },
    {
      question: '¿Se debe entregar un depósito o respaldo?',
      answer: 'Sí. Una vez aprobado el estudio, el arrendatario debe entregar un respaldo económico equivalente a hasta tres cánones de arrendamiento, el cual sirve como garantía frente a posibles obligaciones derivadas del contrato.'
    },
    {
      question: '¿El dinero del respaldo se devuelve?',
      answer: 'Sí. El respaldo se reintegra al finalizar el contrato, una vez la inmobiliaria emita el paz y salvo. Si existen valores pendientes (como servicios, reparaciones o cánones), estos podrán descontarse del valor entregado como respaldo.'
    },
    {
      question: '¿Cuál es el costo del servicio?',
      answer: 'Be Safe cobra un servicio técnico mensual: 2.5% del canon de arrendamiento + IVA si el canon es igual o menor a $2.500.000. 2% del canon de arrendamiento + IVA si el canon es mayor a $2.500.000.'
    },
    {
      question: '¿Qué pasa si el arrendatario se atrasa en el pago?',
      answer: 'En caso de mora en el pago del canon o del servicio, se activa un procedimiento de gestión que puede incluir contacto con el cliente y medidas para la recuperación del inmueble conforme a los acuerdos firmados.'
    },
    {
      question: '¿Qué ventajas tiene usar Be Safe?',
      answer: 'Amplía las posibilidades de arrendamiento. Permite acceder a inmuebles sin depender de una aseguradora tradicional. Ofrece respaldo jurídico y procesos claros. Facilita el acceso a personas o empresas con perfiles no tradicionales en el mercado inmobiliario.'
    }
  ]
})

// Render FAQ section
const faqElement = faq.render()
app.appendChild(faqElement)

// Render contact section
const contactElement = renderContactSection()
app.appendChild(contactElement)

console.log('✓ Navbar renderizado correctamente')
console.log('✓ Hero section renderizada correctamente')
console.log('✓ Services section renderizada correctamente')
console.log('✓ Video Gallery section renderizada correctamente')
console.log('✓ About Us section renderizada correctamente')
console.log('✓ FAQ section renderizada correctamente')
console.log('✓ Contact section renderizada correctamente')

// Attach privacy modal event listeners
const privacyLinks = document.querySelectorAll('[data-privacy-link]')
privacyLinks.forEach(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault()
    const linkText = (link as HTMLElement).getAttribute('data-i18n')
    
    // Open appropriate modal based on link
    if (linkText === 'contact.footer.dataProtection') {
      dataProtectionModal.open()
    } else {
      privacyModal.open()
    }
  })
})

console.log('✓ Privacy modals inicializados correctamente')
console.log('✓ Study request modal inicializado correctamente')

// ============================================
// Scroll-triggered reveal animations
// ============================================
const observerOptions: IntersectionObserverInit = {
  threshold: 0.1,
  rootMargin: '0px 0px -40px 0px'
}

const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('revealed')
      revealObserver.unobserve(entry.target)
    }
  })
}, observerOptions)

// Observe all sections and cards for scroll reveal
const revealTargets = document.querySelectorAll(
  '.service-card, .value-card, .about-content-block, .faq-item, .how-it-works, .contact-column, .hero-left-container, .hero-right-container'
)
revealTargets.forEach(el => {
  el.classList.add('reveal-on-scroll')
  revealObserver.observe(el)
})

console.log('✓ Scroll reveal animations inicializadas correctamente')

// Floating WhatsApp button (fixed bottom-left, links to footer WhatsApp number)
initWhatsAppFloat()
console.log('✓ Botón flotante de WhatsApp inicializado correctamente')
